module.exports = __webpack_public_path__ + "img/AGR-A-2-III.9836d9f5.png";